// extracted by mini-css-extract-plugin
module.exports = {"ModalTab_tab":"ModalTab_ModalTab_tab__t5lBq","isActive":"ModalTab_isActive__1ECNX","ModalTab_header":"ModalTab_ModalTab_header__fp7_r"};